import ViewfinderQrcodeScan from './ViewfinderQrcodeScan';

export default ViewfinderQrcodeScan;
